<template>
  <v-container>
    <v-layout row wrap text-center>
      <v-flex xs-12>
        For any help or support on the portal, email us at
        <a href="mailto:docsoc@ic.ac.uk">docsoc@ic.ac.uk</a>
      </v-flex>
      <v-flex xs12>
        <a class="subtext" href="Privacy Notice.pdf">Privacy Notice</a>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>